<div class="video-action">
  <h1>{{ videoId ? "Edit" : "Add" }} Video</h1>
  <div class="video-action__content">
    <form [formGroup]="videoForm" (submit)="onSubmit()">
      <div class="">
        <div class="input-field">
          <label>Title <span>*</span></label>
          <input
            type="text"
            formControlName="title"
            placeholder="Enter Title"
            inNoWhitespace
            maxlength="100"
          />
          <span
            *ngIf="videoForm.get('title')?.errors?.['required']&&(videoForm.get('title')?.dirty||videoForm.get('title')?.touched)"
          >
            Title is required
          </span>
        </div>

        <div class="flex-wrap justify-between">
          <div class="video-action__form flex-col">
            <div class="input-field flex-col no-space">
              <label>Description <span>*</span></label>
              <textarea
                formControlName="description"
                placeholder="Enter Description"
                inNoWhitespace
              ></textarea>
              <span
                *ngIf="videoForm.get('description')?.errors?.['required']&&(videoForm.get('description')?.dirty||videoForm.get('description')?.touched)"
              >
                Description is required
              </span>
            </div>
          </div>

          <div class="video-action__upload flex-col">
            <label>Upload Video <span>*</span></label>
            <div
              class="video-action__file flex-col align-center justify-center"
            >
              <app-upload-video
                (uploadEnd)="onUploadEnd($event)"
                (uploadStart)="onUploadStart()"
                [previewUrl]="videoPreviewUrl"
                (removeVideo)="removeVideo()"
              ></app-upload-video>
            </div>
            <div
              class="is-error"
              *ngIf="videoForm.get('videoUrl')?.errors?.['required']&&(videoForm.get('videoUrl')?.dirty||videoForm.get('videoUrl')?.touched)"
            >
              Video is required
            </div>
          </div>
        </div>
      </div>
      <div class="video-action__footer flex justify-end">
        <app-button customClass="outline" (action)="cancel()" label="cancel">
        </app-button>
        <app-button
          [isDisabled]="isLoading || videoUploading || initialLoading"
          type="submit"
          label="Submit"
        >
          <app-button-loader
            *ngIf="isLoading"
            postfixContent
          ></app-button-loader>
        </app-button>
      </div>
    </form>
  </div>
</div>
